// Text for the approved offline designs A, C and D (Moeen, Oct 27 2026).
// Kept apart from enumStrings so shared controls such as SectionSaveReset do
// not load the dashboard route list.
export const offlineStrings = {
  bannerTitle: "No internet connection.",
  bannerText:
    "Your changes stay on this page. Save is off until the connection is back.",
  tryAgainButtonText: "Try Again",
  saveOffText: "Save is off while you are offline.",
  screenEyebrow: "No Connection",
  screenTitle: "No Internet Connection",
  screenDescription:
    "Chamber Member Pro cannot open because your computer is not connected to the internet. Check your Wi-Fi or network cable, then try again.",
  screenHint: "The dashboard opens by itself when the connection is back.",
  backOnlineTitle: "You are back online",
  backOnlineText:
    "Your changes are still on this page. Select Save Changes to save them.",
} as const;
